import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconMarket12 from './IconMarket12';
import IconMarket16 from './IconMarket16';
import IconMarket20 from './IconMarket20';
import IconMarket24 from './IconMarket24';
import IconMarket32 from './IconMarket32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconMarket = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconMarket12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconMarket16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconMarket20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconMarket24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconMarket32 {...props} />}
        </span>
    );
};
IconMarket.displayName = 'FondueIconMarket';

export default memo(IconMarket);
